<script setup>

import ChevronLeftIcon from "./ChevronLeftIcon.vue";
import ChevronRightIcon from "./ChevronRightIcon.vue";
import ImageService from "../services/imageService";
import { ref, computed, onBeforeUnmount } from 'vue';

const props = defineProps({
  product: Object,
  item: Object,
  component: Object,
  theme_id: Number,
})

const modal = ref()

const modal_image = ref(null)
const selectedImage = ref(props.product.images?.[0])

const toggleModal = () => {
    if(modal?.value?.open) {
        modal?.value?.classList.add("hide")
        setTimeout(() => modal?.value?.close(), 200)
        window.removeEventListener('keydown', (e) => handleKeydown(e))
    } else {
        modal?.value?.classList.remove("hide")
        modal?.value?.showModal()
        window.addEventListener('keydown', (e) => handleKeydown(e))
    }
}

const currentIndex = computed(() => {
      return props.product.images?.findIndex((i) => i.id == modal_image.value?.id)
})

const numberOfImages = computed(() => {
      return props.product.images?.length ?? 0
})

const setModalImage = (image) => {
  modal_image.value = image
  toggleModal()
}

const url = (image, size) => {
  return ImageService.url(image, size)
}

const nextImage = () => {
  console.log('next', currentIndex, numberOfImages)
  modal_image.value =
    currentIndex.value + 1 === numberOfImages.value
      ? props.product.images[0]
      : props.product.images[currentIndex.value + 1]
}

const previousImage = () => {
  modal_image.value =
    currentIndex.value === 0
      ? props.product.images[numberOfImages.value - 1]
      : props.product.images[currentIndex.value - 1]
}

const startX = ref(null)

const touchStartHandler = (e) => {
    startX.value = e.changedTouches[0].pageX;
}
const touchEndHandler = (e) => {
  const endX = e.changedTouches[0].pageX;
  if(startX.value && Math.abs(startX.value - endX) > 50) {
    e.preventDefault()
  }
  if (startX.value && Math.abs(startX.value - endX) > 50) {
    if (startX.value > endX) {
      nextImage();
    } else {
      previousImage();  
    }
  }

  startX.value = null;
}

const handleKeydown = (e) => {
  if(['ArrowRight', 'd'].includes(e.key)) {
    nextImage()
  } else if(['ArrowLeft', 'a'].includes(e.key)) {
    previousImage()
  }
}

defineExpose({
  toggleModal
})

onBeforeUnmount(() => window.removeEventListener('keydown', (e) => handleKeydown(e)))


</script>

<template>
  <div :class="`grid c_${component.id}__primary_image_container c_${component.id}__primary_image_container_${theme_id ?? ''}`" >
      <img :src="url(selectedImage, item.settings?.primary_image?.image_size ?? 'xl')" :class="`cursor-pointer c_${component.id}__primary_image c_${component.id}__primary_image_${theme_id ?? ''}`" alt="" v-if="selectedImage" @mousedown="setModalImage(selectedImage)">
  </div>
  <div :class="`c_${component.id}__secondary_images_container c_${component.id}__secondary_images_container_${theme_id ?? ''}`">
      <img :src="url(image, item.settings?.secondary_image?.image_size ?? 'sm')" alt="" :class="`cursor-pointer c_${component.id}__secondary_image c_${component.id}__secondary_image_${theme_id ?? ''}`" v-for="image in product.images" @mousedown="selectedImage = image">
  </div>
  
  <dialog ref="modal" class="p-0 bg-transparent">
    <div
        id="modalContainer"  class="items-center w-full"
         
        >
        <div id="leftChevron">
          <button @mousedown.prevent="previousImage" class="chevron-button">
            <chevron-left-icon class="chevron_image_gallery" />
          </button>
        </div>
        <div id="image" class="flex-1  grid justify-center">
          <div class="relative">
            <img :src="url(modal_image, 'xl')" alt="" class="max-h-screen80 shadow" 
            @touchstart="touchStartHandler"
            @touchend="touchEndHandler" 
            />
            <button type="button" class="modal__close absolute top-1 right-1" @click.prevent="toggleModal()">
              <svg
              stroke="inherit"
              fill="none"
              width="1.2rem"
              height="1.2rem"
              viewBox="0 0 24 24"
              
              >
              <path
                  class="inline-flex"
                  stroke-linecap="round"  
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
              />
              </svg>
            </button>
          </div>
        </div>
        <div id="rightChevron">
          <button @mousedown.prevent="nextImage" class="chevron-button">
            <chevron-right-icon class="chevron_image_gallery" />
          </button>
        </div>
    </div>
  </dialog>
</template>


<style>
  .chevron_image_gallery {
    fill: #000000;
    height: '1rem';
    width: '1rem';
  }
  dialog[open] {
    animation: show .3s ease normal;
    width: 100vw;
}
dialog[open]::backdrop {
    animation: showBackdrop .3s ease normal;
}
dialog::backdrop {
    backdrop-filter: blur(5px);
}
dialog.hide {
    animation: hide .3s ease normal;
}
@keyframes show{
    from {
        opacity: 0;
        transform: scale(0);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
}
@keyframes showBackdrop{
    from {
        backdrop-filter: blur(0px);
    }
    to {
        backdrop-filter: blur(5px);
    }
}
@keyframes hide{
    to {
        opacity: 0;
        transform: scale(0);
    }
}

#modalContainer {
  display: grid;
  grid-template-columns: min-content 1fr min-content;
  grid-template-rows: auto;
}
#leftChevron {
  grid-column: 1/2;
  grid-row: 1/2;
  z-index: 1;
}
#image {
  grid-column: 1/4;
  grid-row: 1/2;
}
#rightChevron {
  grid-column: 3/4;
  grid-row: 1/2;
  z-index: 1;
}

</style>